import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { UserRole } from '@upstart/harmony/lib/constants';
import { getCurrentUser } from '../../redux/user/selectors';
import { getCurrentUserPermissions } from '../../redux/permissions/selectors';

const hasPermission = (user, resource, permission) => {
  const roles = get(user, 'roles', []);

  // Always true for admin roles
  if (
    roles.includes(UserRole.ADMIN) ||
    roles.includes(UserRole.SUPER_ADMIN) ||
    roles.includes(UserRole.READ_ONLY_ADMIN)
  ) {
    return true;
  }

  return (resource || []).includes(permission);
};

/**
 * HOC to conditionally render components based on user permissions
 */
export default (resourceName, permission) => Component => {
  function Wrapper(props) {
    const { currentUser, currentUserPermissions } = props;
    const resource = get(currentUserPermissions, resourceName);

    // Render component if permission exists
    if (hasPermission(currentUser, resource, permission)) {
      return <Component {...props} />;
    }

    // Otherwise return nothing
    return null;
  }

  Wrapper.propTypes = {
    currentUser: PropTypes.object,
    currentUserPermissions: PropTypes.object,
  };

  const mapStateToProps = state => ({
    currentUser: getCurrentUser(state),
    currentUserPermissions: getCurrentUserPermissions(state),
  });

  return connect(mapStateToProps)(Wrapper);
};
